/**
 * しおりの位置（readHistory の readingProgress。読書画面が 0〜1 で送る）の決まり。
 * api/read/progress（残すかどうか）とホームの「続きを読む」（読みかけに数えるか）が読む。
 */

/** ここまで来たら最後まで読んだとみなす */
export const READ_TO_END = 0.99;

/**
 * 読了済みの本を最後まで読み返した位置か。読みかけとしては残さない
 * （読了の後にもう一度開いて最後までスクロールすると 100% の読みかけが残り、ホームの「続きを読む」から消えなくなっていた）。
 * まだ読了していない本は 100% でも読みかけのまま（読了を押してもらうため）
 */
export function isFinishedReread(readCount: number, progress: number): boolean {
  return readCount > 0 && progress >= READ_TO_END;
}
